import React, { useState } from 'react';

import './addBook.css';

const AddBook = () => {
    
    const [formData, setFormData] = useState({
        title: '',
        type: '',
        description: '',
        price: ''
    });

    
    const [bookData, setBookData] = useState(null);

    // Handle change
    const handleChange = (e) => {
        setFormData((prev) => ({
            ...prev,
            [e.target.id]: e.target.value,
        }))
    }



    // Submit logic
    const submitHandler = async (event) => {
        event.preventDefault();

        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/books`, {
                method: 'POST',
                headers: {
                    'Content-Type' : 'application/json'
                },
                body: JSON.stringify(formData)
            });

            const responseData = await response.json();
            setBookData(responseData);
            console.log('Book added', responseData);
            // console.log('book Data: ', bookData)
        }catch (err) {
            console.error('Error adding book: ', err.message)
        }
    }



    return (
        <main className='addBook-form-container'>
            {/* <h1>Adding Book</h1> */}
            <form onSubmit={submitHandler} className='addBook-form'>
                <label htmlFor='title'>Судрын нэр</label>
                <input type='text' id='title' value={formData.title} onChange={handleChange} placeholder='Номын нэрийг бичнэ үү' />

                <label htmlFor='type'>Төрөл</label>
                <input type='text' id='type' value={formData.type} onChange={handleChange} placeholder='Номын төрлийг бичнэ үү...'/>

                <label htmlFor='description'>Тайлбар</label>
                <textarea type='text' id='description' value={formData.description} onChange={handleChange} placeholder='Номын тайбар бичнэ үү...'/>

                <label htmlFor='price'>Үнэ</label>
                <input type='number' id='price' value={formData.price} onChange={handleChange} placeholder='₮...'/>

                <button type='submit'>Нэмэх</button>
            </form>
        </main>
    )
}
export default AddBook;